export const firebaseConfig = {
  apiKey: 'AIzaSyDU2hefQrtyVTeauiJ5OBLPu1MPB0bxou0',
  authDomain: 'projectzen-164715.firebaseapp.com',
  databaseURL: 'https://projectzen-164715.firebaseio.com',
  storageBucket: 'projectzen-164715.appspot.com',
  messagingSenderId: '21082801805',
};
